import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tabs, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ReactCardFlip from "react-card-flip";
import { useDispatch } from "react-redux";
import liracrypt from "../../components/Liracrypt/liracrypt";
import SessionError from "../../components/ApiErrorComp/SessionError";
import PerformanceTrend from "./Graph/PerformanceTrend";
import LineDashBarChart from "./Graph/LineDashBarChart";
import ScanPart from "./ScanPart";
import SOP from "./Tables/SOP";
import LineDashPlanning from "./LineDashPlanning";
import HotLine from "./HotLine";
import LineDash4MReport from "./LineDash4MReport";
import Andon from "./Andon/AndonPage";
import { deepEqual, getStyleProperties } from "../../utils/CustomFunc";
import LineDashReport from "./LineDashReport";
import OnlineLineReport from "../../components/Reports/OnlineDefectEntryTab";
import DateBasedLine from "./Graph/LineChart";
import ETrail from "./ETrail";
import ETrailDual from "./EtrailDual";
import HotLine2 from "./Hotline2";
import RoutePage from "../../components/RoutePage";
import ScanterStable from "./ScanterStable";
import FG3pSeating from "./FG3pSeating";


const { TabPane } = Tabs;

const RightContainer = (props) => {
    const [loginError, setLoginError] = useState(false);
    const dispatch = useDispatch();
    const [rightContainer, setRightContainer] = useState(null);
    const [selectedTab, setSelectedTab] = useState("");
    const [addonLoaded, setAddonLoaded] = useState(false);
    const [andonstatus, setAndonstatus] = useState(null);

    const [andonBlock, setAndonBlock] = useState(null);
    const [isFlipped, setIsFlipped] = useState(false);

    // const [andonstatusLoaded, setAndonstatusLoaded] = useState(false);
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    useEffect(() => {
        setSelectedTab(props.settings.ld_Tab_Main.defaultTab)
        setInterval(
            () => {
                // console.log(isFlipped);
                setIsFlipped((prev) => !prev);
            },
            props.flipInterval ? props.flipInterval : 10000
        );
    }, []);


    const fetchAndonDetail = () => {
        liracrypt
            .get("/linedashboard/andonstatus", { lid: props.selectedLid })
            .then(({ data }) => {
                dispatch({
                    type: 'andonStatus',
                    payload: {
                        andonColor: data.data.andonColor === 'G' ? 'Andon Green' :
                            data.data.andonColor === 'R' ? 'Andon Red' :
                                data.data.andonColor === 'O' ? 'Andon Orange' :
                                    data.data.andonColor === 'B' ? 'Andon Blue' :
                                        'Andon Green',
                        andonData: data.data
                    }
                });
                // console.log(data);
                // console.log("LineDash Call");
                if (!andonstatus) {
                    setAndonstatus(data.data);
                    setAndonBlock(data.data.escDetails);
                } else {
                    if (!deepEqual(andonstatus, data)) {
                        setAndonstatus(data.data);
                    }
                }
                setAddonLoaded(true);
            })
            .catch(function (error) {
                // console.log("Error****:", error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        // ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    };

    const handleAndonStatus = (updated) => {
        setAddonLoaded(false);
        if (updated === true) {
            fetchAndonDetail();
        } else {
            setAddonLoaded(true);
        }
    };

    useEffect(() => {
        fetchAndonDetail();
        let andonInterval = setInterval(() => {
            fetchAndonDetail();
        }, 30000);


        if (rightContainer === null) {
            let dataBlock = [];
            Object.keys(props.settings).forEach((key, index) => {
                // console.log(key);
                if (key.includes("ld_DataBlock_")) {
                    dataBlock.push({
                        text: props.settings[key].text,
                        text_style: getStyleProperties(props.settings[key].legend),
                        value: props.settingValues[key],
                        value_style: getStyleProperties(props.settings[key].data),
                        numbeOfBlock: props.settings.ld_main.dataBlocks,
                        backgroundColor: props.settings[key]["background-color"],
                        width: 80 / props.settings.ld_main.dataBlocks + "%",
                    });
                }
            });

            // console.log(dataBlock);

            setRightContainer({
                dataBlock: dataBlock,
                andon: props.settings.ld_Andon,
                tabs: props.settings.ld_Tab_Main,
            });
        }
        return () => {
            clearInterval(andonInterval);
        }
        // }, 10000);
    }, []);

    const getTabsPannel = (tab) => {
        const tabCap = tab;
        // const tabCap = tab.toUpperCase();
        // const tabCap = tab.toUpperCase()
        // console.log(tab, tabCap);
        switch (tabCap) {
            case "PerformanceTrend":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDashBarChart selectedLid={props.selectedLid} selectedTab="OEE" />
                        </div>
                    </>
                );
            case "PMH":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDashBarChart selectedLid={props.selectedLid} selectedTab="PMH" />
                        </div>
                    </>
                );
            case "ProdnQty":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDashBarChart selectedLid={props.selectedLid} selectedTab="ProdnQty" />
                        </div>
                    </>
                );
            case "DLE":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDashBarChart selectedLid={props.selectedLid} selectedTab="DLE" />
                        </div>
                    </>
                );
            case "ScanPart":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <FG3pSeating selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "ScanPartSeating":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <FG3pSeating selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "ETrail":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <ETrail selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "QRScanner":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <ScanterStable selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "ETrailDual":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <ETrailDual selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "SOP":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <SOP selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "Planning":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDashPlanning lid={props.selectedLid} />
                        </div>
                    </>
                );
            case "Hotline":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div style={{ padding: "40px 10px" }}>
                            <HotLine selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "Training":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div style={{ padding: "40px 10px" }}>
                            <HotLine2 selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
            case "Links":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div style={{ padding: "40px 10px" }}>
                            <RoutePage route={"/zfcustom"} params={{ typ: "ZfLineDashLink", subTyp: "", selectedLid: props.selectedLid }} />
                        </div>
                    </>
                );
            // case "QUALITY":
            case "Reports":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDashReport lid={props.selectedLid} />
                        </div>
                    </>
                );
            case "4M":
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <LineDash4MReport lid={props.selectedLid} />
                        </div>
                    </>
                );
            //     break;
            case "Andon":
                return addonLoaded ? (
                    <>
                        <SessionError visible={loginError} />
                        <Andon
                            settingValues={props.settingValues}
                            andonstatus={andonstatus}
                            handleAndonStatusCallback={handleAndonStatus}
                            selectedLid={props.selectedLid}
                            andonBlock={andonBlock}
                            lid={props.selectedLid}
                        />
                    </>
                ) : (
                    <>
                        <SessionError visible={loginError} />
                        <div className="Loading">
                            <Spin indicator={antIcon} />
                        </div>
                    </>
                );
            // case "OTHERS":

            case "Quality":
                return (
                    <>
                        <OnlineLineReport
                            setPageHeader={() => { }}
                            marginLeft={"145px"}
                            fetchAndonDetail={fetchAndonDetail}
                            lid={props.selectedLid}
                        />
                    </>
                );

            //     break;
            default:
                return (
                    <>
                        <SessionError visible={loginError} />
                        <div>
                            <DateBasedLine selectedLid={props.selectedLid} />
                        </div>
                    </>
                );
        }
    };

    return (
        <>
            <SessionError visible={loginError} />
            <React.Fragment>
                {rightContainer !== null ? (
                    <>
                        <Row style={{ padding: 10, justifyContent: 'space-between' }}>
                            {rightContainer.dataBlock.map((block, index) => {
                                if (index <= props.settings.ld_main.dataBlocks - 1) {
                                    let loc = index + 1;
                                    let locNext = index + 4;
                                    let f = rightContainer.dataBlock[loc - 1];
                                    let b = rightContainer.dataBlock[locNext];
                                    return (
                                        <>
                                            {f && b ? (
                                                <Col
                                                    xs={12} sm={12} md={Math.floor(24 / (rightContainer.dataBlock.length / 2))} lg={Math.floor(24 / (rightContainer.dataBlock.length / 2))}
                                                    style={{ width: block.width }}
                                                    key={"datablock_" + index}
                                                >
                                                    <ReactCardFlip
                                                        isFlipped={isFlipped}
                                                        flipDirection="vertical"
                                                    >
                                                        <div
                                                            style={{
                                                                textAlign: "center",
                                                                padding: "5px 20px",
                                                                border: 0,
                                                                backgroundColor: block.backgroundColor
                                                                    ? block.backgroundColor
                                                                    : "#3b3b3b",
                                                                boxShadow:
                                                                    "5px 5px 9px #171717,-5px -5px 9px #232323",
                                                                borderRadius: "10px",
                                                                fontWeight: "600",
                                                            }}
                                                            className="borderBox"
                                                        >
                                                            <p
                                                                style={{
                                                                    ...block.value_style,
                                                                    margin: "2px 0",
                                                                }}
                                                            >
                                                                {props.dBlock ? props.dBlock["lD_DataBlock_0" + loc] : ""}
                                                            </p>
                                                            <p
                                                                style={{
                                                                    ...block.text_style,
                                                                    margin: "2px 0",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {block.text}
                                                            </p>
                                                        </div>

                                                        <div
                                                            style={{
                                                                textAlign: "center",
                                                                padding: "5px 20px",
                                                                border: 0,
                                                                backgroundColor: rightContainer.dataBlock[
                                                                    locNext
                                                                ].backgroundColor
                                                                    ? rightContainer.dataBlock[locNext]
                                                                        .backgroundColor
                                                                    : "#3b3b3b",
                                                                boxShadow:
                                                                    "5px 5px 9px #171717,-5px -5px 9px #232323",
                                                                borderRadius: "10px",
                                                                fontWeight: "600",
                                                            }}
                                                            className="borderBox"
                                                        >
                                                            <p
                                                                style={{
                                                                    ...rightContainer.dataBlock[locNext]
                                                                        .value_style,
                                                                    margin: "2px 0",
                                                                }}
                                                            >
                                                                {/* {localStorage.getItem(`DataBlock${index + 1}`)} */}
                                                                {
                                                                    props.dBlock ?
                                                                        props.dBlock[
                                                                        "lD_DataBlock_0" + (locNext + 1)
                                                                        ] : ""
                                                                }
                                                            </p>
                                                            <p
                                                                style={{
                                                                    ...rightContainer.dataBlock[locNext]
                                                                        .text_style,
                                                                    margin: "2px 0",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {rightContainer.dataBlock[locNext].text}
                                                            </p>
                                                        </div>
                                                    </ReactCardFlip>
                                                </Col>
                                            ) : (
                                                <>
                                                    <Col
                                                        style={{ width: block.width }}
                                                        key={"datablock_" + index}
                                                    >
                                                        <div
                                                            style={{
                                                                textAlign: "center",
                                                                padding: "5px 20px",
                                                                border: 0,
                                                                backgroundColor: block.backgroundColor,
                                                                boxShadow:
                                                                    "5px 5px 9px #171717,-5px -5px 9px #232323",
                                                                borderRadius: "10px",
                                                                fontWeight: "600",
                                                            }}
                                                            className="borderBox"
                                                        >
                                                            <p
                                                                style={{
                                                                    ...block.value_style,
                                                                    margin: "2px 0",
                                                                }}
                                                            >
                                                                {/* {localStorage.getItem(`DataBlock${index + 1}`)} */}
                                                                {props.dBlock ? props.dBlock["lD_DataBlock_0" + loc] : ""}
                                                            </p>
                                                            <p
                                                                style={{
                                                                    ...block.text_style,
                                                                    margin: "2px 0",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {block.text}
                                                            </p>
                                                        </div>
                                                    </Col>
                                                </>
                                            )}
                                        </>
                                    );
                                }
                            })}
                        </Row>
                        <Row style={{ padding: 10 }} justify={"center"}>
                            <Col
                                span={24}
                            >
                                <div
                                    className="TabsPanel borderBox"
                                    style={{
                                        padding: "10px",

                                        overflow: "hidden",
                                        backgroundColor: rightContainer.tabs["background-color"],
                                        borderRadius: "10px",
                                        border: 0,
                                        boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                                        // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                                    }}
                                >
                                    <Tabs
                                        defaultActiveKey={selectedTab}
                                        type="card"
                                        tabPosition={"top"}
                                        tabBarStyle={{ border: 0 }}
                                        onChange={(activeKey) => setSelectedTab(activeKey)}
                                    >
                                        {rightContainer.tabs.text.map((tab, i) => (
                                            <TabPane tab={tab} key={tab}></TabPane>
                                        ))}
                                        {/* <TabPane tab={"ETrailDual"} key={"ETrailDual"}>ETrailDual</TabPane> */}
                                    </Tabs>
                                    <div>
                                        {getTabsPannel(selectedTab)}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </>
                ) : null}
            </React.Fragment>
        </>
    );
};
export default RightContainer;